import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../ui/button';

interface ManageReportsPaginationProps {
    page: number;
    limit: number;
    total: number;
    isDisabled?: boolean;
    onPrevious: () => void;
    onNext: () => void;
}

const ManageReportsPagination: React.FC<ManageReportsPaginationProps> = ({
    page,
    limit,
    total,
    isDisabled = false,
    onPrevious,
    onNext,
}) => {
    const totalPages = Math.max(Math.ceil(total / limit), 1);
    const rangeStart = total === 0 ? 0 : (page - 1) * limit + 1;
    const rangeEnd = total === 0 ? 0 : Math.min(page * limit, total);

    return (
        <div className="flex flex-col gap-3 border-t pt-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm text-muted-foreground">
                Showing {rangeStart}-{rangeEnd} of {total} cases
            </p>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                <span className="text-sm text-muted-foreground">
                    Page {page} of {totalPages}
                </span>
                <div className="flex items-center gap-2">
                    <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        disabled={isDisabled || page <= 1}
                        onClick={onPrevious}
                    >
                        <ChevronLeft className="h-4 w-4" />
                        Previous
                    </Button>
                    <Button
                        type="button"
                        variant="outline"
                        size="sm"
                        disabled={isDisabled || page >= totalPages}
                        onClick={onNext}
                    >
                        Next
                        <ChevronRight className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ManageReportsPagination;
